//#region src/types/HostActionFacet.ts
var e = /* @__PURE__ */ function(e) {
	return e.Stay = "STAY", e.StayChange = "STAY_CHANGE", e.Guests = "GUESTS", e.Count = "COUNT", e.Text = "TEXT", e;
}({});
//#endregion
export { e as HostActionFacetKind };
